import { useSelector } from 'react-redux';
import useShowKBBPromo from '@/vdp/StickyBanner/useShowKBBPromo';
import Tag from '@/vdp/Tags/Tag';
import Sections from '~/constants/sections';
import SubSections from '~/constants/subSections';
import { useIsMobile } from '~/context/common/DeviceContext';
import { usePriceDrop } from '~/hooks/vdp';
import { getSoonestRoute } from '~/selectors';
import getTagGetItBy from '~/utilities/date/getTagGetItBy';

const Tags = () => {
  const isMobile = useIsMobile();
  const showKBBPromo = useShowKBBPromo();
  const { showPriceDrop, restrictedState } = usePriceDrop();
  const route = useSelector(getSoonestRoute);
  const date = getTagGetItBy(route);

  return (
    <div className="flex flex-wrap gap-4">
      {showPriceDrop && (
        <a
          className="pointer-events-auto"
          data-analytics-id="Hero Header - New Price Tag"
          data-qa="new-price-badge"
          href={
            isMobile ? `#${SubSections.NewPrice}` : `#${Sections.AboutThePrice}`
          }
        >
          <Tag
            text={restrictedState ? 'New Price' : 'Price Drop'}
            bgColor="bg-green-2"
            bigTag={!isMobile}
          />
        </a>
      )}
      {showKBBPromo && (
        <a
          className="pointer-events-auto"
          data-analytics-id="Hero Header - Great Deal Tag"
          data-qa="great-deal-tag"
          href={
            isMobile
              ? `#${SubSections.GreatDeal}`
              : `#${Sections.AboutThePrice}`
          }
        >
          <Tag text="Great Deal" bgColor="bg-blue-4" bigTag={!isMobile} />
        </a>
      )}
      {date && (
        <a
          className="pointer-events-auto"
          data-analytics-id="Hero Header - Delivery Tag"
          data-qa="delivery-tag"
          href={`#${Sections.EarliestDelivery}`}
        >
          <Tag
            text={date}
            border
            blueText
            bgColor="bg-white"
            bigTag={!isMobile}
          />
        </a>
      )}
    </div>
  );
};

export default Tags;
